import { z } from 'zod';

export const CompositeDataSetGenerateReportInsightsIdleResult = z.object({
  type: z.literal('idle'),
});

export type CompositeDataSetGenerateReportInsightsIdleResult = z.infer<
  typeof CompositeDataSetGenerateReportInsightsIdleResult
>;

export const CompositeDataSetGenerateReportInsightsLoadingResult = z.object({
  type: z.literal('loading'),
});

export type CompositeDataSetGenerateReportInsightsLoadingResult = z.infer<
  typeof CompositeDataSetGenerateReportInsightsLoadingResult
>;

export const CompositeDataSetGenerateReportInsightsErrorResult = z.object({
  type: z.literal('error'),
  errorType: z.string(),
  errorReason: z.string(),
});

export type CompositeDataSetGenerateReportInsightsErrorResult = z.infer<
  typeof CompositeDataSetGenerateReportInsightsErrorResult
>;

export const CompositeDataSetReportInsights = z.object({
  reportName: z.string(),
  insights: z.object({
    rowCount: z.number(),
    columns: z.array(
      z.object({
        column: z.string(),
        coverage: z.number(),
        dataType: z.string(),
      }),
    ),
  }),
});

export type CompositeDataSetReportInsights = z.infer<
  typeof CompositeDataSetReportInsights
>;

export const CompositeDataSetReportsInsights = z.array(
  CompositeDataSetReportInsights,
);

export type CompositeDataSetReportsInsights = z.infer<
  typeof CompositeDataSetReportsInsights
>;

export const CompositeDataSetGenerateReportInsightsSuccessResult = z.object({
  type: z.literal('success'),
  reportsInsights: CompositeDataSetReportsInsights,
});

export type CompositeDataSetGenerateReportInsightsSuccessResult = z.infer<
  typeof CompositeDataSetGenerateReportInsightsSuccessResult
>;

export const CompositeDataSetGenerateReportInsightsResult = z.union([
  CompositeDataSetGenerateReportInsightsIdleResult,
  CompositeDataSetGenerateReportInsightsLoadingResult,
  CompositeDataSetGenerateReportInsightsErrorResult,
  CompositeDataSetGenerateReportInsightsSuccessResult,
]);

export type CompositeDataSetGenerateReportInsightsResult = z.infer<
  typeof CompositeDataSetGenerateReportInsightsResult
>;
